import React, { PureComponent } from 'react';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip'
import Fade from '@mui/material/Fade';
import './users.css'

const UserAvatar = class UserAvatar extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isShow: false,
            isAvatarExist: false,
            name: '',
            shortName: ''
        };

        this.loadAvatar = this.loadAvatar.bind(this);
    }

    componentDidMount() {
        if (this.props.userId === '00000000-0000-0000-0000-000000000000' || !this.props.userId) {
            this.setState({ isShow: false });
            return;
        }

        this.loadAvatar();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userId !== this.props.userId) {
            this.loadAvatar();
        }
    }

    loadAvatar() {
        var scope = this;
        var userInfo = localStorage.getItem(this.props.userId);
        var userExpired = localStorage.getItem(this.props.userId + 'exp');
        if (new Date(userExpired) < new Date()) userInfo = null;
        if (userInfo) {
            scope.setState(JSON.parse(userInfo));
        }
        else {
            fetch('api/User/GetAvatarInfo?userId=' + this.props.userId, {
                method: 'GET',
                body: null,
            }).then(function (res) {
                if (res.status === 404) {
                    scope.setState({ isShow: false });
                }
                else {
                    res.json().then((result) => {
                        localStorage.setItem(scope.props.userId, JSON.stringify({ isShow: true, isAvatarExist: result.isAvatarExist, name: result.name, shortName: result.shortName }));
                        var now = new Date();
                        now.setDate(now.getDate() + 1);
                        localStorage.setItem(scope.props.userId + 'exp', now);
                        scope.setState({ isShow: true, isAvatarExist: result.isAvatarExist, name: result.name, shortName: result.shortName });
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    render() {
        return (
            <Tooltip TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} title={this.state.name} placement="bottom-end">
                <div className="avatar-inner-block">
                {this.state.isShow &&
                    <div>
                        {this.state.isAvatarExist && <Avatar alt={this.state.name} src={"/api/User/GetAvatar?userId=" + this.props.userId}></Avatar>}
                        {!this.state.isAvatarExist && <Avatar className="avatar" alt={this.state.name}>{this.state.shortName}</Avatar>}
                    </div>
                }
                </div>
            </Tooltip>
        );
    }
}

export default React.memo(UserAvatar);